export default __webpack_public_path__ + "static/media/plus-green-bg.d2fbb6a4.svg";